import { useQuery } from '@tanstack/react-query';

import UsersService from '~/services/UsersService';

import { usersQueryKeys } from './usersQueryKeys';

type Params = {
  userId: string;
  brand: string;
  enabled?: boolean;
};

/**
 * A single user record, keyed by brand so switching tenant refetches.
 */
export function useGetUser({ userId, brand, enabled = true }: Params) {
  return useQuery({
    queryKey: usersQueryKeys.detail(brand, userId),
    queryFn: async ({ signal }) => {
      return await UsersService.getUser(userId, { brand, signal });
    },
    enabled: enabled && !!userId,
  });
}
